import Modal from "react-modal";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Cross from "resources/images/svg/cross-white.svg";
import { Carousel } from "react-responsive-carousel";
import { HorizontalFlex, Sect, VerticalFlex } from "../pandora/styled";
import { darkGreen } from "resources/newColors";
import { triggerDownload, addGpsExifToDataUrl } from "Utils/Utils";
import { useCtx } from "context/SessionDataContext";
import { imageData } from "DTO/userWorkOrderListDto";

type props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  imageIndex: number;
  selectedUserImage: imageData[];
};

const style = {
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    border: "none",
    overflow: "hidden",
    background: "rgba(0,0,0,0.29)",
  },
};

export default function ImageSlider({
  modalIsOpen,
  closeModal,
  imageIndex,
  selectedUserImage,
}: Readonly<props>) {
  Modal.setAppElement("body");
  Modal.defaultStyles.overlay.zIndex = 1056;

  const { currentWorkOrder, isMobile } = useCtx();

  const downloadImages = (
    fileURL: string,
    index: number,
    latitude?: number,
    longitude?: number
  ) => {
    fetch(fileURL)
      .then((response) => response.blob())
      .then((blob) => {
        const correctedBlob = blob.slice(0, blob.size, "image/jpeg");

        if (correctedBlob.type !== "image/jpeg" || !longitude || !latitude) {
          console.warn(
            "GPS injection skipped: not a JPEG. Or missing GPS data."
          );
          return triggerDownload(blob, index, currentWorkOrder);
        }

        const reader = new FileReader();
        reader.onloadend = async () => {
          const dataUrl = reader.result as string;

          const updatedDataUrl = addGpsExifToDataUrl(
            dataUrl,
            latitude,
            longitude
          );
          const updatedBlob = await fetch(updatedDataUrl).then((res) =>
            res.blob()
          );
          triggerDownload(updatedBlob, index, currentWorkOrder);
        };

        reader.readAsDataURL(correctedBlob);
      });
  };
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={style}
      contentLabel="Images"
    >
      <VerticalFlex
        css={`
          position: relative;
          background-color: ${darkGreen};
          padding: 20px;
          ${isMobile && "width: 100%;"}
        `}
      >
        <HorizontalFlex css="justify-content: flex-end;">
          <Sect
            css={`
              justify-content: flex-end;
              cursor: pointer;
              position: absolute;
              background-color: ${darkGreen};
              padding: 10px 20px;
              top: -25px;
              right: 0;
              z-index: 100;
            `}
            onClick={() => {
              closeModal();
            }}
          >
            <img style={{ height: 20, width: "auto" }} src={Cross} alt="" />
          </Sect>
        </HorizontalFlex>
        <Carousel
          showArrows={true}
          selectedItem={imageIndex}
          emulateTouch
          showThumbs={false}
          width={isMobile ? "100%" : 896}
          useKeyboardArrows={true}
          autoPlay={false}
        >
          {selectedUserImage?.map((data, index) => {
            const { url, latitude, longitude } = data;
            return (
              <div key={url + index}>
                <img
                  key={url}
                  src={
                    url ??
                    `https://img.icons8.com/pastel-glyph/64/000000/error.png`
                  }
                  style={{
                    height: 504,
                    width: "auto",
                  }}
                  alt=""
                />
                <button
                  className="legend"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    downloadImages(url, index, latitude, longitude)
                  }
                >
                  Download
                </button>
              </div>
            );
          })}
        </Carousel>
      </VerticalFlex>
    </Modal>
  );
}
